import { useCallback, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";
import { selectSearchText } from "app/pages/sales-intelligence/modules/leads-search/store/selectors";
import { selectFiltersValue } from "app/pages/sales-intelligence/modules/leads-search-filters";

import { setAppsIsRowSelectionEnabled, setAppsSelectedRows } from "../store/action-creators";

export const useClearAndCloseAppsRowsSelection = (): VoidFunction => {
    const dispatch = useDispatch();

    const searchText = useSelector(selectSearchText);
    const filtersValue = useSelector(selectFiltersValue);

    const clearAndCloseRowsSelection = useCallback((): void => {
        dispatch(setAppsIsRowSelectionEnabled(false));
        dispatch(setAppsSelectedRows([]));
    }, []);

    useEffect(() => {
        dispatch(setAppsSelectedRows([]));
    }, [searchText, filtersValue]);

    useUnmount(() => {
        clearAndCloseRowsSelection();
    });

    return clearAndCloseRowsSelection;
};
